// Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
       Made with <span style={{ color: 'red', fontSize: '24px' }}>&hearts;</span> by Kiran
    </footer>
  );
};

export default Footer;
